
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteScenario",
      resolverType: "mutation",
      routePath: "/deleteScenario",
      httpMethod: "POST",
    });
  